import type { TableColumn } from "../../../../../../components/table";

export const tableColumns: TableColumn<any>[] = [
  {
    title: "STT",
    size: "medium",
    renderCell: (row, index) => index,
  },
  {
    title: "Người sử dụng",
    size: "medium",
    renderCell: (row) => row.Users,
  },
  {
    title: "Mã nhân viên",
    renderCell: (row) => row.EmployeeCode,
  },
  {
    title: "Bộ phận công tác",
    size: "medium",
    renderCell: (row) => row.WorkingDepartment,
  },
  {
    title: "Chức danh",
    renderCell: (row) => row.Title,
  },
  {
    title: "Hệ thống",
    renderCell: (row) => row.System,
  },
  {
    title: "Nhóm User",
    renderCell: (row) => row.FunctionCode,
  },
  {
    title: "User ID (Đã cấp)",
    renderCell: (row) => row.CaseHasBeenGranted,
  },
  {
    title: "Đề nghị",
    size: "large",
    renderCell: (row) => row.Request,
  },
  {
    title: "Chi tiết đề nghị",
    size: "large",
    renderCell: (row) => row.DetailedDescriptionOfTheRequest,
  },
  {
    title: "Sân bay trực thuộc",
    renderCell: (row) => row.CodePcc,
  },
  {
    title: "Email",
    size: "large",
    renderCell: (row) => row.Email,
  },
  {
    title: "Số điện thoại",
    renderCell: (row) => row.PhoneNumber,
  },
  {
    title: "CMND/CCCD",
    renderCell: (row) => row.IdUser,
  },
];

export const tableChangeColumns: TableColumn<any>[] = [
  {
    title: "STT",
    size: "medium",
    renderCell: (row, index) => index,
  },
  {
    title: "Người sử dụng",
    size: "medium",
    renderCell: (row) => row.Users,
  },
  {
    title: "Mã nhân viên",
    renderCell: (row) => row.EmployeeCode,
  },
  {
    title: "Bộ phận công tác",
    size: "medium",
    renderCell: (row) => row.WorkingDepartment,
  },
  {
    title: "Chức danh",
    renderCell: (row) => row.Title,
  },
  {
    title: "Hệ thống",
    renderCell: (row) => row.System,
  },
  {
    title: "Nhóm User",
    renderCell: (row) => row.FunctionCode,
  },
  {
    title: "User ID (Đã cấp)",
    renderCell: (row) => row.CaseHasBeenGranted,
  },
  {
    title: "Duty Code",
    renderCell: (row) => row.DutyCode,
  },
  {
    title: "Office",
    renderCell: (row) => row.Office,
  },
  {
    title: "Đề nghị",
    size: "large",
    renderCell: (row) => row.Request,
  },
  {
    title: "Chi tiết đề nghị",
    size: "large",
    renderCell: (row) => row.DetailedDescriptionOfTheRequest,
  },
  {
    title: "Sân bay trực thuộc",
    renderCell: (row) => row.CodePcc,
  },
  {
    title: "Email",
    size: "large",
    renderCell: (row) => row.Email,
  },
  {
    title: "Số điện thoại",
    renderCell: (row) => row.PhoneNumber,
  },
  {
    title: "CMND/CCCD",
    renderCell: (row) => row.IdUser,
  },
];
